// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Vtp1K","best":"_3aOhh6","bestseller":"DEgY9s","content":"lJe6GT","price":"_2KFktM","shine-lines":"_2IyKXr"};